export const MARKETING_SITE_URL = (
  process.env.REACT_APP_MARKETING_SITE_URL || 'https://spintasker.com'
).replace(/\/$/, '');

/** app.spintasker.com (ili REACT_APP_APP_HOST) — samo aplikacija, bez marketing sajta */
export const isAppHost = (hostname = typeof window !== 'undefined' ? window.location.hostname : '') => {
  const host = String(hostname || '').toLowerCase();
  if (!host) return false;

  const forced = process.env.REACT_APP_FORCE_APP_HOST;
  if (forced === 'true' || forced === '1') return true;

  if (process.env.REACT_APP_FORCE_MARKETING_HOST === 'true' || process.env.REACT_APP_FORCE_MARKETING_HOST === '1') {
    return false;
  }

  const appHost = (process.env.REACT_APP_APP_HOST || 'app.spintasker.com').toLowerCase();
  if (host === appHost) return true;

  return host.startsWith('app.') && host.endsWith('spintasker.com');
};

/** Početna stranica — uvek marketing (spintasker.com), nikad app root na app hostu */
export const getMarketingHomeUrl = () => {
  if (typeof window !== 'undefined' && isAppHost()) {
    return MARKETING_SITE_URL;
  }
  return '/';
};

export const isMarketingHost = (hostname) => !isAppHost(hostname);
